package devxertech.com.style

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.silk.components.style.hover
import com.varabyte.kobweb.silk.style.CssStyle
import devxertech.com.theme.Palette

val DropdownStyleLight = CssStyle {
    hover {
        Modifier.backgroundColor(Palette.Primary.rgbLight)
    }
}
val DropdownStyleDark = CssStyle {
    hover {
        Modifier.backgroundColor(Palette.Secondary.rgbDark)
    }
}